import { api } from "@/lib/api-client";
import type { LegalPage, LegalPageInput } from "./types";

export const legalPagesApi = {
  publicList: () => api.get<Array<Pick<LegalPage, "slug" | "title" | "updatedAt">>>("/legal-pages"),
  publicBySlug: (slug: string) => api.get<LegalPage>(`/legal-pages/${slug}`),
  list: () => api.get<LegalPage[]>("/legal-pages/manage"),
  update: (id: string, input: LegalPageInput) => api.patch<LegalPage>(`/legal-pages/${id}`, input),
};
